import React from "react";
import styled from "styled-components";

const Faqs = React.forwardRef((props, ref) => {
  return (
    <div>
      <FaqsSection ref={ref}>
        <FaqsHeading>Frequently Asked Questions</FaqsHeading>
        <FaqsContainer>
          <FaqColumn>
            <FaqItem>
              <FaqLabel>Question</FaqLabel>
              <FaqContent>Do you offer same-day delivery?</FaqContent>
            </FaqItem>
            <FaqItem>
              <FaqLabel>Answer</FaqLabel>
              <FaqContent>
                Yes, we offer same-day delivery for select items and locations.
              </FaqContent>
            </FaqItem>
          </FaqColumn>

          <FaqColumn>
            <FaqItem>
              <FaqLabel>Question</FaqLabel>
              <FaqContent>
                What types of products are available in the marketplace?
              </FaqContent>
            </FaqItem>
            <FaqItem>
              <FaqLabel>Answer</FaqLabel>
              <FaqContent>
                We offer a variety of fresh produce, organic goods, and sustainable farming supplies.
              </FaqContent>
            </FaqItem>
          </FaqColumn>

          <FaqColumn>
            <FaqItem>
              <FaqLabel>Question</FaqLabel>
              <FaqContent>How can I become a seller on Ina-Ani?</FaqContent>
            </FaqItem>
            <FaqItem>
              <FaqLabel>Answer</FaqLabel>
              <FaqContent>
                You can sign up on our website and submit an application to become a verified seller.
              </FaqContent>
            </FaqItem>
          </FaqColumn>
        </FaqsContainer>
      </FaqsSection>

      <TeamSection>
        <TeamHeading>Our Team</TeamHeading>
        <TeamContainer>
          <TeamMember>
            <TeamImage src="team-member-1.jpg" alt="Team Member 1" />
            <TeamName>John Doe</TeamName>
            <TeamRole>Founder & CEO</TeamRole>
          </TeamMember>
          <TeamMember>
            <TeamImage src="team-member-2.jpg" alt="Team Member 2" />
            <TeamName>Jane Smith</TeamName>
            <TeamRole>COO</TeamRole>
          </TeamMember>
          <TeamMember>
            <TeamImage src="team-member-3.jpg" alt="Team Member 3" />
            <TeamName>Emily Johnson</TeamName>
            <TeamRole>Marketing Director</TeamRole>
          </TeamMember>
        </TeamContainer>
      </TeamSection>
    </div>
  );
});

export default Faqs;

/* STYLED COMPONENTS */
const FaqsSection = styled.section`
  min-height: 100vh;
  padding: 2rem;
  background: #eaf4e1;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FaqsHeading = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  margin-top: 7rem;
  color: green;
`;

const FaqsContainer = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const FaqColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FaqItem = styled.div`
  background: #228b22;
  color: white;
  border-radius: 15px;
  padding: 1rem;
  width: 280px;
  position: relative;
`;

const FaqLabel = styled.div`
  position: absolute;
  top: -10px;
  left: 10px;
  background: white;
  color: black;
  padding: 0.2rem 0.8rem;
  border-radius: 15px;
  font-weight: bold;
  font-style: italic;
  font-size: 0.9rem;
  border: 2px solid black;
`;

const FaqContent = styled.p`
  font-size: 1rem;
  text-align: center;
  font-style: italic;
  margin-top: 1.5rem;
`;

const TeamSection = styled.section`
  padding: 2rem;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  max-height: 400px; /* Set maximum height for scrolling */
  overflow-y: auto; /* Enable vertical scrolling */
`;

const TeamHeading = styled.h3`
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #333;
`;

const TeamContainer = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const TeamMember = styled.div`
  text-align: center;
  width: 200px;
`;

const TeamImage = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 10px;
`;

const TeamName = styled.h4`
  font-size: 1.2rem;
  margin-top: 0.5rem;
  color: #333;
`;

const TeamRole = styled.p`
  font-size: 1rem;
  color: #666;
`;
